import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: "#141311" }} data-testid="payment-cancel-page">
      <div className="max-w-md w-full p-10 text-center" style={{ border: "1px solid rgba(168,152,128,0.35)" }}>
        <h1 className="lp-h text-3xl" style={{ color: "#F5F1EA" }}>Checkout cancelled.</h1>
        <p className="text-sm mt-4" style={{ color: "#B5AC9E" }}>No charge was made. Whenever you're ready, FENYX will be here.</p>
        <Link to="/fenyx" className="inline-block mt-6 px-10 py-3.5 lp-label-sm transition-opacity hover:opacity-85"
          style={{ background: "#A89880", color: "#141311" }} data-testid="cancel-back-link">Back to FENYX</Link>
      </div>
    </div>
  );
}
